import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=5d34465a&scoped=true&"
import script from "./resetPwd.vue?vue&type=script&lang=js&"
export * from "./resetPwd.vue?vue&type=script&lang=js&"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=5d34465a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34465a",
  null
  
)

export default component.exports